import { gql } from 'graphql.macro'
import ActionFragment from '../../lib/ActionFragment'

export default gql`
  query Action($id: ID!) {
    action(id: $id) {
      ...ActionFragment
    }
  }

  ${ActionFragment}
`
